import Icon from 'veui/components/Icon'
import { IconThumbDown } from 'dls-icons-vue'

Icon.register('thumb-down', IconThumbDown)
